export function normalizeLocaleCode(input) {
  const map = {
    en: 'en',    // English
    si: 'sl',    // Slovenian (correct tag is 'sl')
    de: 'de',    // German
    rs: 'sr',    // Serbian (Latin or Cyrillic, but 'sr' is general)
    me: 'sr-ME', // Montenegrin (not always well supported; fallback to 'sr-ME')
    hr: 'hr',    // Croatian
    mk: 'mk',    // Macedonian
    it: 'it',    // Italian
    pl: 'pl',    // Polish
    ro: 'ro',    // Romanian
    nl: 'nl',    // Dutch
    ee: 'et',    // Estonian
    sk: 'sk',    // Slovak
    cz: 'cs',    // Czech (ISO code is 'cs')
    fr: 'fr',    // French
    es: 'es',    // Spanish
  };

  const normalized = input?.toLowerCase?.();
  return map[normalized] || 'en'; // fallback to 'en'
}

export function reverseLocaleCode(input) {
  const reverseMap = {
    en: 'us',    // English
    sl: 'si',    // Slovenian
    de: 'de',    // German
    sr: 'rs',    // Serbian
    'sr-me': 'me',    // Montenegrin
    hr: 'hr',    // Croatian
    mk: 'mk',    // Macedonian
    it: 'it',    // Italian
    pl: 'pl',    // Polish
    ro: 'ro',    // Romanian
    nl: 'nl',    // Dutch
    et: 'ee',    // Estonian
    sk: 'sk',    // Slovak
    cs: 'cz',    // Czech
    fr: 'fr',    // French
    es: 'es',    // Spanish
  };

  const normalized = input?.toLowerCase?.();
  return reverseMap[normalized] || 'us'; // fallback to 'en'
}